module.exports = __webpack_public_path__ + "img/luvuyo-ntsime.ba160eab.png";